import React from 'react';
import { ActionMenu, resolveMenuItems } from '@milanote/roma/application';
import type { MenuSize } from '@milanote/roma';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { useSelector } from 'react-redux';
import { userLocalePreferenceSelector } from '../../../../../../user/currentUserSelector';
import { insertMenuConfig, InsertMenuContext } from './insertMenuPopupConfig';

export type InsertMenuToolbarPopupProps = {
    closePopup: () => void;
    size: MenuSize;
    isTaskListContext: boolean;
};

const InsertMenuToolbarContent: React.FC<InsertMenuToolbarPopupProps> = ({
    closePopup,
    size = 'xs',
    isTaskListContext,
}) => {
    const translate = useTranslator('toolbar', 'tools.editing.insertMenu') as (localeKey: string) => string;
    const locale: string = useSelector(userLocalePreferenceSelector);

    const context: InsertMenuContext = {
        translate,
        locale,
        isTaskListContext,
        // TODO: Proper actions to be added in separate tickets
        insertEmoji: closePopup,
        insertBoardLink: closePopup,
        insertDividerLine: closePopup,
        insertMention: closePopup,
    };

    const nodes = resolveMenuItems(insertMenuConfig, context);

    return <ActionMenu.Content aria-label="Insert menu actions" nodes={nodes} autoFocus size={size} showIcons />;
};

export default InsertMenuToolbarContent;
